export default state => {
  return {
    userProfile: state.profile.userInfo,
    aSyncCall: state.profile.aSyncCall,
    minorAsyncCall: state.profile.minorAsyncCall
  };
};


// WEBPACK FOOTER //
// ./src/selectors/profileSelector.js